import { Tokens } from '@/Services/Auth/types';

export const checkTokens = (tokens: Partial<Tokens> | undefined): boolean => {
    return !(!tokens || !tokens.access || !tokens.refresh);
};
